import { setPublicPath } from 'systemjs-webpack-interop';

setPublicPath('partners-widget-basket');
